document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.openAxeptioCookies').forEach((l) => {
    if ( typeof openAxeptioCookies == "undefined" || !l.getAttribute('href')) {
      return;
    }
    l.href = 'javascript:openAxeptioCookies()';
  });
});
